module.exports = __webpack_public_path__ + "img/w25-cover.ee534f0f.jpg";